import { useEffect } from 'react';
import { ActiveProps } from './active';
import { useDeepLink } from '~/utils/active/deeplink';

type Awaited<T extends Promise<unknown>> = T extends Promise<infer U> ? U : never;
export type RelatedApps = Awaited<ReturnType<NonNullable<typeof window.navigator.getInstalledRelatedApps>>> | undefined;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const delay = (timeout: number) => new Promise<undefined>((resolve) => setTimeout(resolve, timeout));

const DEFAULT_TIMEOUT = 10000;
const LEMON8_PKG_ID = 'com.bd.nproject';

type RelatedParams = {
  awakenOptions: Omit<ActiveProps, 'ampExtraOption'>;
  hasFulfilled?: boolean;
};

interface relatedAppData {
  id?: string;
  platform: string;
  version?: string;
  url?: string;
}

const getIsClient = (): boolean => {
  return typeof window !== 'undefined';
};

export const getRelatedApps = async (params?: RelatedParams): Promise<RelatedApps> => {
  if (!getIsClient()) {
    return Promise.resolve(undefined);
  }

  if (window?.navigator?.getInstalledRelatedApps) {
    return Promise.race([window.navigator.getInstalledRelatedApps(), delay(DEFAULT_TIMEOUT)]);
  }
  return Promise.resolve(undefined);
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useSilentAwaken = (props: RelatedParams) => {
  const { awakenOptions, hasFulfilled = false } = props;
  const { schemaOption } = awakenOptions;
  const pid = 'sharing_install';
  const openUrl = useDeepLink({
    ...schemaOption,
    pid,
  });

  useEffect(() => {
    const ua = window.navigator.userAgent;
    const isAndroid = /android/i.test(ua);

    if (isAndroid) {
      // wait for the ending of stream rendering
      if (hasFulfilled) {
        getRelatedApps(props)
          .then((relatedApps) => {
            if (relatedApps && relatedApps.length > 0) {
              const lemon8AppInfo: relatedAppData = relatedApps.find((app) => app.id.includes(LEMON8_PKG_ID));
              if (lemon8AppInfo) {
                window.Tea('wap_with_app', {
                  installed_app_name: lemon8AppInfo.id,
                  installed_app_version: lemon8AppInfo.version,
                });
                location.href = openUrl;
              }
            } else {
              location.href = openUrl;
            }
          })
          .catch((err) => {
            console.warn('getRelatedApps failed', err);
            location.href = openUrl;
          });
      }
    }
  }, [hasFulfilled]);
};
